import React, { useEffect, useRef, useState } from "react";
import { IconDotsVertical, IconDownload } from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import AssignDriver from "./AssignDriver";
import PickupViewModal from "./PickupViewModal";
import {
  useAssignDriverMutation,
  useFetchPickupData,
} from "../../../apis/pickupApis";
import formatDate from "../../../utilities/helper";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import NewCommonModal from "../../../components/common/NewCommonModal";

type FormValues = {
  pickupId: string;
  driverId: string;
  vehicleId: string;
  driverContact: string;
};

const PickupRequestTab: React.FC = () => {
  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const { data: pickupData, refetch: pickupRefetch } = useFetchPickupData(
    1,
    10,
    ""
  );
  const { mutate, isPending } = useAssignDriverMutation();
  const [pickupItem, setPickupItem] = useState<any>(null);
  const openShelveToggleModal = (item?: any) => {
    setPickupItem(item);
    setOpenShelve(!openShelve);
  };
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAssignDriver = async (data: any) => {
    mutate(
      { ...data },
      {
        onSuccess: (data) => {
          openShelveToggleModal(null);
          reset();
          pickupRefetch();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };
  return (
    <>
      <div className="rounded-3xl">
        <div className="flex items-start">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[30px] ">
            <h1 className="text-3xl text-[#212121]">Lists</h1>
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch />
            </div>
          </div>
          <div className="relative ml-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={40}
              height={40}
              viewBox="0 0 34 34"
              fill="none"
              className="absolute -bottom-[12.5px] -left-[22.5px] rotate-[2deg] "
            >
              <path
                d="M0.5 0.5C4.94768 14.4784 15.2221 25.8511 28.6786 31.6907L34 34H2.31268L0.5 0.5Z"
                fill="#F7F6F2"
              />
            </svg>

            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>
        <div>
          {" "}
          <ListView
            data={pickupData?.pickupRequests ?? []}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "#", render: (_, i) => i + 1 },
              {
                label: "Pickup ID",
                render: (c) => c.pickupId,
              },
              {
                label: "Shipments",
                render: (c) => c.shipmentsCount || "",
              },
              { label: "Merchant Name", render: (c) => c.clientName || "" },
              {
                label: "Email",
                render: (c) => c.email || "",
              },
              {
                label: "Phone",
                render: (c) => c.phone || "",
              },
              {
                label: "City",
                render: (c) => c.city || "",
              },
              {
                label: "Address",
                render: (c) => c.fullAddress || "",
              },
              {
                label: "Date & Time",
                render: (c) =>
                  `${formatDate(c.pickupDate)} ${c.timeSlot}` || "",
              },
              {
                label: "Driver Name",
                render: (c) => (
                  <span className="bg-[#EEEEEE] px-2 py-1 rounded-full">
                    {c.driverName || "Not Assigned"}
                  </span>
                ),
              },
              {
                label: "Actions",
                render: (c: any) => (
                  <div className="relative">
                    <button
                      onClick={() =>
                        setOpenDropdownIndex(openDropdownIndex === c ? null : c)
                      }
                      className="p-2 border rounded-full bg-[#F7F6F2]"
                    >
                      <IconDotsVertical />
                    </button>

                    {openDropdownIndex === c && (
                      <div
                        ref={dropdownRef}
                        className="absolute bg-[#F7F6F2] divide-y divide-[#979797]/50 right-20 -top-2 z-50 mt-2 w-32 rounded-xl shadow-lg overflow-hidden"
                      >
                        <div
                          onClick={openModal}
                          className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                        >
                          View Details
                        </div>
                        <div
                          onClick={() => {
                            openShelveToggleModal(c);
                            setValue("pickupId", c.id);
                          }}
                          className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                        >
                          Assign Driver
                        </div>
                      </div>
                    )}
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>

      <NewCommonModal
        title={"Assign Driver"}
        open={openShelve}
        closeButtonText={"Cancel"}
        onClose={() => {
          openShelveToggleModal(null);
          reset();
          clearErrors();
        }}
        actionButtonText="Assign Now "
        actionButtonOnClick={handleSubmit(handleAssignDriver)}
        isPending={isPending}
      >
        <AssignDriver
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          control={control}
          reset={reset}
          pickupItem={pickupItem}
        />
      </NewCommonModal>
      <PickupViewModal open={isOpen} onClose={closeModal} />
    </>
  );
};

export default PickupRequestTab;
